module.exports = __webpack_public_path__ + "static/contact-d61d61877eebe5f2706f4b6ce1f60a14.jpg";